import { render } from "./SettingsView.vue?vue&type=template&id=4f599ea2&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=4f599ea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f599ea2"],['__file',"src/views/SettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f599ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f599ea2', __exports__)) {
    api.reload('4f599ea2', __exports__)
  }
  
  module.hot.accept("./SettingsView.vue?vue&type=template&id=4f599ea2&scoped=true", () => {
    api.rerender('4f599ea2', render)
  })

}


export default __exports__